// js/custom-element/section/cart/cart-drawer.js
if (!customElements.get('cart-drawer')) {
  var CartDrawer = class extends DrawerContent {
    connectedCallback() {
      super.connectedCallback();
      this.nextReplacementDelay = 0;
      this.rootDelegate.on('cart:refresh', this._rerenderCart.bind(this));
      this.addEventListener('variant:added', () => (this.nextReplacementDelay = 600));
    }
    async _rerenderCart(event) {
      let cartContent = null,
        html = '';
      if (event.detail && event.detail['cart'] && event.detail['cart']['sections']) {
        cartContent = event.detail['cart'];
        html = event.detail['cart']['sections']['mini-cart'];
      } else {
        const response = await fetch(`${window.themeVariables.routes.cartUrl}?section_id=${this.getAttribute('section')}`);
        html = await response.text();
      }
      const fakeDiv = document.createElement('div');
      fakeDiv.innerHTML = html;
      setTimeout(async () => {
        const previousPosition = this.querySelector('.drawer__content').scrollTop;
        if (cartContent && cartContent['item_count'] === 0) {
          const animation = new CustomAnimation(
            new ParallelEffect(
              Array.from(this.querySelectorAll('.drawer__content, .drawer__footer')).map((item) => {
                return new CustomKeyframeEffect(item, { opacity: [1, 0] }, { duration: 250, easing: 'ease-in' });
              })
            )
          );
          animation.play();
          await animation.finished;
        }
        this.innerHTML = fakeDiv.querySelector('cart-drawer').innerHTML;
        if (cartContent && cartContent['item_count'] === 0) {
          this.querySelector('.drawer__content').animate({ opacity: [0, 1], transform: ['translateY(40px)', 'translateY(0)'] }, { duration: 450, easing: 'cubic-bezier(0.33, 1, 0.68, 1)' });
        } else {
          this.querySelector('.drawer__content').scrollTop = previousPosition;
        }
        if (event?.detail?.openMiniCart) {
          this.clientWidth;
          this.open = true;
        }
      }, event?.detail?.replacementDelay || this.nextReplacementDelay);
      this.nextReplacementDelay = 0;
    }
    async attributeChangedCallback(name, oldValue, newValue) {
      super.attributeChangedCallback(name, oldValue, newValue);
      switch (name) {
        case 'open':
          if (this.open) {
            this.querySelector('.drawer__content').scrollTop = 0;
            if (!MediaFeatures.prefersReducedMotion()) {
              const lineItems = Array.from(this.querySelectorAll('.line-item')),
                recommendationsInner = this.querySelector('.mini-cart__recommendations-inner'),
                bottomBar = this.querySelector('.drawer__footer'),
                effects = [];
              if (recommendationsInner && window.matchMedia(window.themeVariables.breakpoints.pocket).matches) {
                lineItems.push(recommendationsInner);
              }
              lineItems.forEach((item) => (item.style.opacity = 0));
              recommendationsInner ? (recommendationsInner.style.opacity = 0) : null;
              bottomBar ? (bottomBar.style.opacity = 0) : null;
              effects.push(
                new ParallelEffect(
                  lineItems.map((item, index) => {
                    return new CustomKeyframeEffect(
                      item,
                      {
                        opacity: [0, 1],
                        transform: ['translateX(40px)', 'translateX(0)'],
                      },
                      {
                        duration: 400,
                        delay: 400 + 120 * index - Math.min(2 * index * index, 120 * index),
                        easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
                      }
                    );
                  })
                )
              );
              if (bottomBar) {
                effects.push(
                  new CustomKeyframeEffect(
                    bottomBar,
                    {
                      opacity: [0, 1],
                      transform: ['translateY(100%)', 'translateY(0)'],
                    },
                    {
                      duration: 300,
                      delay: 400,
                      easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
                    }
                  )
                );
              }
              if (recommendationsInner && !window.matchMedia(window.themeVariables.breakpoints.pocket).matches) {
                effects.push(
                  new CustomKeyframeEffect(
                    recommendationsInner,
                    {
                      opacity: [0, 1],
                      transform: ['translateX(100%)', 'translateX(0)'],
                    },
                    {
                      duration: 250,
                      delay: 400 + Math.max(120 * lineItems.length - 25 * lineItems.length, 25),
                      easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
                    }
                  )
                );
              }
              let animation = new CustomAnimation(new ParallelEffect(effects));
              animation.play();
            }
          }
      }
    }
  };
  window.customElements.define('cart-drawer', CartDrawer);
}

// js/custom-element/section/cart/cart-drawer-recommendations.js
if (!customElements.get('cart-drawer-recommendations')) {
  var _CartDrawerRecommendations = class _CartDrawerRecommendations extends HTMLElement {
    async connectedCallback() {
      if (!_CartDrawerRecommendations.recommendationsCache[this.productId]) {
        _CartDrawerRecommendations.recommendationsCache[this.productId] = fetch(`${window.themeVariables.routes.productRecommendationsUrl}?product_id=${this.productId}&limit=10&section_id=${this.sectionId}`);
      }
      const response = await _CartDrawerRecommendations.recommendationsCache[this.productId];
      const div = document.createElement('div');
      div.innerHTML = await response.clone().text();
      const productRecommendationsElement = div.querySelector('cart-drawer-recommendations');
      if (productRecommendationsElement && productRecommendationsElement.hasChildNodes()) {
        this.innerHTML = productRecommendationsElement.innerHTML;
      } else {
        this.hidden = true;
      }
    }
    get productId() {
      return this.getAttribute('product-id');
    }
    get sectionId() {
      return this.getAttribute('section-id');
    }
  };
  __publicField(_CartDrawerRecommendations, 'recommendationsCache', {});
  var CartDrawerRecommendations = _CartDrawerRecommendations;
  window.customElements.define('cart-drawer-recommendations', CartDrawerRecommendations);
}
